import { me, setProfilePhoto, getProfilePhoto, getProfilePhotoList } from '../../api/apiIndex'
import router from '../../router/index'
import { Message } from 'element-ui';
import i18n from "../../utils/lang/index.js";

export default {
  state: {
    userInfo: {
      id: null,
      name: "",
      d7_map: "",
      day7_id: "",
      bridge_password_token: "",
      bridge_password: "",
      nickname: null,
      realname: null,
      email: null,
      phone: "",
      qq: null,
      gender: 0,
      invite_code: "",
      money: 0,
      fs_money: 0,
      ml_money: "0.00",
      total_money: "0.00",
      total_slot_money: "0.00",
      total_live_money: "0.00",
      score: "0.00",
      register_ip: "",
      register_area: "N/A",
      register_site: "",
      status: null,
      is_tips_on: null,
      is_in_on: null,
      is_trans_on: null,
      is_demo: null,
      lang: "",
      top_id: null,
      agent_id: null,
      total_credit: "0.00",
      used_credit: "0.00",
      level: null,
      slot_level: null,
      live_level: null,
      level_name: "",
      created_at: "",
      updated_at: "",
      deleted_at: null,
      site: "",
      is_ms_reg: null,
      has_qk_pwd: false
    },
    listMalePhoto: [],
    listFemalePhoto: [],
    userProfilePhoto: '',
    pageBackgroundImg: '',
  },
  getters: {},
  mutations: {
    setUserInfo(state, userInfo) {
      state.userInfo = userInfo
    },
    setPageBackgroundImg(state, data) {
      state.pageBackgroundImg = data
    },
    setMalePhoto(state, data) {
      state.listMalePhoto = data
    },
    setFemalePhoto(state, data) {
      state.listFemalePhoto = data
    },
    setUserProfilePhoto(state, photo) {
      state.userProfilePhoto = photo
    }
  },
  actions: {
    getUserInfo(context) {
      me().then(res => {
        context.commit("setUserInfo", res.data)
        context.dispatch('getProfilePhoto', res.data.id)
      }).catch(err => {
        if(err.response.status == 401){
          if(err.response.data.force_offline){
            sessionStorage.clear();
            localStorage.clear();
            Message.error(i18n.t('network-error'))
          }
          context.state.userInfo = {
            id: null,
            name: "",
            d7_map: "",
            day7_id: "",
            bridge_password_token: "",
            bridge_password: "",
            nickname: null,
            realname: null,
            email: null,
            phone: "",
            qq: null,
            gender: 0,
            invite_code: "",
            money: 0,
            fs_money: 0,
            ml_money: "0.00",
            total_money: "0.00",
            total_slot_money: "0.00",
            total_live_money: "0.00",
            score: "0.00",
            register_ip: "",
            register_area: "N/A",
            register_site: "",
            status: null,
            is_tips_on: null,
            is_in_on: null,
            is_trans_on: null,
            is_demo: null,
            lang: "",
            top_id: null,
            agent_id: null,
            total_credit: "0.00",
            used_credit: "0.00",
            level: null,
            slot_level: null,
            live_level: null,
            level_name: "",
            created_at: "",
            updated_at: "",
            deleted_at: null,
            site: "",
            is_ms_reg: null,
            has_qk_pwd: false
          }
          // if(location.pathname != ''){
          //   location.pathname = '/'
          // }
          // context.commit('setLoginModalStatus', true);
        }
        // context.commit("setLoginModalStatus", true);
      })
    },
    getProfilePhotosList(context) {
      getProfilePhotoList().then(res => {
        context.commit("setMalePhoto", res.males)
        context.commit("setFemalePhoto", res.females)
      })
    },
    getProfilePhoto(context, params) {
      getProfilePhoto(params).then(res => {
        // update user profile photo
        context.commit("setUserProfilePhoto", res.profileurl)
      })
    },
    setProfilePhoto(context, params) {
      setProfilePhoto(params).then(res => {
        // update user profile photo
        context.commit("setUserProfilePhoto", res.profileurl)

        // retrieve user profile photo
        context.dispatch('getProfilePhoto', params.member_id)
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/vuex/modules/auth.js